import React from 'react';
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';


class MultilineEllipsisText extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false,
      isTruncated: false,
    };
  }

  handleTruncate(isTruncated) {
    if (this.state.isTruncated !== isTruncated) {
      this.setState({
        isTruncated,
      });
    }
  }

  toggleLines() {
    this.setState(({ isExpanded }) => {
      return { isExpanded: !isExpanded };
    });
  }

  render() {
    const { children, more, less, maxLinesCount, isToggleLines } = this.props;

    const { isExpanded, isTruncated } = this.state;

    return (
      <div onClick={isToggleLines && (() => this.toggleLines())}>
        <Truncate
          lines={!isExpanded && parseInt(maxLinesCount, 10)}
          ellipsis={<span>{more}</span>}
          onTruncate={() => this.handleTruncate()}>
          {children}
        </Truncate>
        {!isTruncated && isExpanded && (
          <span onClick={() => this.toggleLines()}>{less}</span>
        )}
      </div>
    );
  }
}


MultilineEllipsisText.defaultProps = {
  children: '',
  maxLines: 3,
  more: '…',
};

MultilineEllipsisText.propTypes = {
  more: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
  maxLinesCount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default MultilineEllipsisText;
